export default __webpack_public_path__ + "static/media/silueta-hombre.fb07851e.png";